var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", { staticClass: "confirm", on: { close: _vm.close } }, [
    _c(
      "h3",
      {
        staticClass: "mt-0",
        attrs: { slot: "modal-header" },
        slot: "modal-header"
      },
      [_vm._t("modal-header")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-body" }, slot: "modal-body" },
      [_vm._t("modal-body")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
      [
        _c("CompassButton", {
          attrs: {
            label: _vm.$t.__("common.actions.cancel"),
            type: "secondary"
          },
          on: { click: _vm.close }
        }),
        _vm._v(" "),
        _c("CompassButton", {
          attrs: { label: _vm.$t.__("common.actions.confirm") },
          on: { click: _vm.confirm }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }